export default __webpack_public_path__ + "static/media/sublevel3_2.fd878d00.webp";